import Rate from './Rate';

// export types
export type { RateProps } from './Rate';

// export components
export { Rate };
export default Rate;
